let config;

if (process.env.NODE_ENV === "development") {
  config = require("./config/config.development");
} else if (process.env.NODE_ENV === "test") {
  config = require("./config/config.test");
} else {
  config = require("./config/config.production");
}

export default config;
